module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-container"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "item",
    style: (("background-image: url('" + (_vm.item.imageURL) + "')")),
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "left-title"
  }, [_c('h2', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.item.title))])]), _vm._v(" "), _c('div', {
    staticClass: "right-title"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.item.platform) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "flag-icon",
    class: ("flag-icon-" + (_vm.item.country.toLowerCase()))
  })]), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onDelete($event)
      }
    }
  }) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d98fa90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Item.vue
// module id = 281
// module chunks = 1